import styled from 'styled-components'
import {Button} from './button.styled'

export const LargestButton = styled(Button)`
    width: 50px;
`
